import { render, staticRenderFns } from "./EmployerInfo.vue?vue&type=template&id=47f970fb"
import script from "./EmployerInfo.vue?vue&type=script&lang=js"
export * from "./EmployerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports